import { http } from "@/utils/http";
import { toQueryString } from "@/utils/live";
import { getToken } from "@/utils/auth";
import type { PublicRes } from "@/types/publicRes";
import type { GetProductTemplateStructureRes } from "@/types/myProduct/newProduct";
import { getAcceptLanguageConfig } from "@/utils/languageUtils";
import { HTTP_HEADERS } from "@/config/httpHead";

/** 获取多米与产品（GET） */
export const getDomeFishProduct = async (params: {
  pageNo?: number;
  pageSize?: number;
  name?: string;
}) => {
  const query = params ? `?${toQueryString(params)}` : "";
  return await http.get<any, any>(`/product/getDomeFishProduct${query}`);
};

/** 保存产品信息（POST） */
export const saveProduct = async (data?: any) => {
  return await http.post<any, any>("/product/saveProduct", {
    data
  });
};

/** 更新产品信息（POST） */
export const updateProduct = async (data?: any) => {
  return await http.put<any, any>("/product/updateProduct", {
    data
  });
};
/** 更新产品信息remark */
export const saveOrUpdateRemark = async (data?: any) => {
  return await http.post<any, any>("/product/saveOrUpdateRemark", {
    data
  });
};

/** 分页查询产品列表（POST） */
export const listProducts = async (data?: any) => {
  // const params = data ? `?${toQueryString(data)}` : "";
  return await http.post<any, any>("/product/listProducts", {
    data
  });
};

/** 获取产品详情（GET） */
export const getProduct = async (params: { id?: string }) => {
  return await http.get<any, any>(`/product/getProduct/${params.id}`);
};

/** 删除产品信息（GET） */
export const deleteProduct = async (params: { id?: string }) => {
  return await http.delete<any, any>(`/product/deleteProduct/${params.id}`);
};

/** 获取产品详情（GET） */
// export const getProductList = async (data: any) => {
//   return await http.get<any, any>("/product/getProductList", {
//     data
//   });
// };

/** 获取产品参数字段 */
export const getValueMappings = async (data: any) => {
  return await http.get<any, any>(`/product/getValueMappings`, {
    data
  });
};

/** 获取产品参数字段映射 */
export const getMapMappings = async (data: any) => {
  return await http.get<any, any>(`/product/getMapMappings`, {
    data
  });
};

/** 更新产品信息并重新生成AI话术  备用 */
export const updateMapMappings = async (data: any) => {
  return await http.put<any, any>(`/product/updateMapMappings`, {
    data
  });
};

/** 保存产品信息  备用 */
export const saveMapMappings = async (data: any) => {
  return await http.post<any, any>(`/product/saveMapMappings`, {
    data
  });
};

/** 商品流式输出处理 - 直接使用axios上传文件（避开http封装） */
export const processProduct = async (formData: FormData) => {
  // 获取语言配置
  const { acceptLanguageHeader } = getAcceptLanguageConfig();
  const token = getToken();
  // 对于流式响应，我们需要使用fetch而不是axios
  return await fetch(`${HTTP_HEADERS.Http}/product/process`, {
    method: "POST",
    headers: {
      Authorization: token,
      "X-Access-Token": token,
      Accept: "text/event-stream",
      "accept-language": acceptLanguageHeader
      // 不设置Content-Type，让浏览器自动设置multipart/form-data
    },
    body: formData
  });
};

/**
 * 获取话术模板结构
 */
export const getProductTemplateStructure = async (params: any) => {
  const query = params ? `?${toQueryString(params)}` : "";
  return await http.get<PublicRes<GetProductTemplateStructureRes[]>, any>(
    `/product/getTemplateStructure${query}`
  );
};

/***
 * @desc 更新商品时需要进行语种验证，验证接口/product/checkLanguage，语种更换时，如果存在直播间引用则不让更新（根据接口返回的判断是否允许更新）
 */
export const checkProductLaacceegghknu = async (params: {
  productld: string;
  language: string;
}) => {
  const query = params ? `?${toQueryString(params)}` : "";
  return await http.get<PublicRes<GetProductTemplateStructureRes[]>, any>(
    `/product/checkLanguage${query}`
  );
};
